import React from 'react'
import { Card, Layout } from 'antd'

type Props = {
  /** Optional left panel, e.g. a Layout.Sider holding the section menu. */
  sider?: React.ReactNode;
  /**
   * Drops the padded white surface and renders the children directly next to
   * the sider. For pages that manage their own full-bleed layout, such as the
   * map on /data, where a card behind the content looks like one merged block.
   */
  plain?: boolean;
  children?: React.ReactNode;
}

/**
 * The shared page frame: optional sider, then a padded area holding the
 * white content surface itself. Follows the antd "Common Layout" example.
 *
 * The padding and the white surface belong to the shell alone. Pages must not
 * add their own background or padding on top of it, otherwise the content
 * ends up as a white rectangle inside a white rectangle with doubled gaps.
 */
const PageShell: React.FC<Props> = ({ sider, plain = false, children }) => {
  if (plain) {
    return (
      <Layout style={{ flex: 1, minHeight: 0 }}>
        {sider}
        {children}
      </Layout>
    )
  }

  return (
    <Layout style={{ flex: 1, minHeight: 0 }}>
      {sider}
      <Layout style={{ padding: '12px' }}>
        <Card>
          {children}
        </Card>
      </Layout>
    </Layout>
  )
}

export default PageShell
